import { ref, onMounted, onBeforeUnmount } from 'vue'

/**
 * Reactive media query match. Updates when the viewport crosses the breakpoint.
 * @param {string} query - Media query string (e.g. '(max-width: 639px)')
 * @returns {import('vue').Ref<boolean>}
 */
export function useMediaQuery(query) {
  const matches = ref(false)
  let mql = null

  function update() {
    matches.value = mql?.matches ?? false
  }

  onMounted(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    mql = window.matchMedia(query)
    update()
    mql.addEventListener('change', update)
  })

  onBeforeUnmount(() => {
    mql?.removeEventListener('change', update)
  })

  return matches
}
